module.exports = __webpack_public_path__ + "img/next_grey.52e5cca0.svg";